import { render } from "./LoggingCatalogue.vue?vue&type=template&id=8b08bf68&ts=true"
import script from "./LoggingCatalogue.vue?vue&type=script&lang=ts"
export * from "./LoggingCatalogue.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\BuildAgent\\work\\330398ee0e098db7\\LoadingSokoldok\\Loading\\loading_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__